export default __webpack_public_path__ + "static/media/en.ce80ab3c.svg";